var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoordonnees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coordonnees") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 35.2c-9.706 0-17.6-7.894-17.6-17.6s7.894-17.6 17.6-17.6c9.706 0 17.6 7.894 17.6 17.6s-7.894 17.6-17.6 17.6zM30.4 3.2c-7.939 0-14.4 6.461-14.4 14.4s6.461 14.4 14.4 14.4c7.939 0 14.4-6.461 14.4-14.4s-6.461-14.4-14.4-14.4z",
    fill: "#223654"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 64h-51.2c-2.646 0-4.8-2.154-4.8-4.8 0-0.218 0.045-5.392 3.92-10.56 2.256-3.008 5.344-5.398 9.181-7.101 4.685-2.083 10.506-3.139 17.299-3.139s12.614 1.056 17.299 3.139c3.837 1.706 6.925 4.093 9.181 7.101 3.875 5.168 3.92 10.342 3.92 10.56 0 2.646-2.154 4.8-4.8 4.8zM30.4 41.6c-11.158 0-19.392 3.050-23.811 8.819-3.312 4.323-3.386 8.742-3.389 8.787 0 0.877 0.717 1.594 1.6 1.594h51.2c0.883 0 1.6-0.717 1.6-1.6 0-0.038-0.074-4.458-3.389-8.781-4.422-5.77-12.656-8.819-23.811-8.819z",
    fill: "#223654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoordonnees);
export default __webpack_public_path__ + "static/media/coordonnees.1db35275fb567f7be30df21e4b0e0524.svg";
export { ForwardRef as ReactComponent };